import type { FormEvent } from "react";

import { useDialogForm, useToast } from "@/ds";
import { solicitarAlteracaoCotacao } from "@/modules/financeiro-obras";
import { useChaveIdempotencia } from "@/shared/hooks";
import { JUSTIFICATIVA_OBRIGATORIA } from "@/shared/components";
import { formatTaxa } from "../planejamento-controle.format";
import {
  O_QUE_ACONTECE_TEXTO,
  SOLICITACAO_ENVIADA_MESSAGE,
  SOLICITAR_COTACAO_FORM_ID,
} from "./solicitar-cotacao-dialog.constants";
import type { SolicitarCotacaoDialogProps } from "./types-solicitar-cotacao-dialog";

export function useSolicitarCotacaoDialog({
  obraId,
  moeda,
  vigente,
  nova,
  onClose,
  onSolicitada,
}: SolicitarCotacaoDialogProps) {
  const toast = useToast();
  const { comChave } = useChaveIdempotencia();

  const form = useDialogForm<{ justificativa: string }>({
    initial: { justificativa: "" },
    validate: ({ justificativa }) =>
      justificativa.trim() === "" ? { justificativa: JUSTIFICATIVA_OBRIGATORIA } : {},
    onSubmit: async ({ justificativa }) => {
      const body = { cotacao: nova, justificativa: justificativa.trim() };
      await comChave(body, (idempotencyKey) =>
        solicitarAlteracaoCotacao(obraId, moeda.id, body, { idempotencyKey }),
      );
      toast.info(SOLICITACAO_ENVIADA_MESSAGE);
      onSolicitada();
    },
  });

  const { justificativa } = form.values;

  return {
    formId: SOLICITAR_COTACAO_FORM_ID,
    moedaCodigo: moeda.codigo,
    moedaNome: moeda.nome,
    vigente: formatTaxa(vigente),
    nova: formatTaxa(nova),
    aviso: O_QUE_ACONTECE_TEXTO(formatTaxa(vigente)),
    justificativa,
    justificativaError: form.errors.justificativa ?? null,
    isSubmitting: form.isSubmitting,
    submitError: form.submitError,
    digitarJustificativa: (texto: string) => form.setValue("justificativa", texto),
    enviar: (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      void form.submit();
    },
    cancelar: onClose,
  };
}
